import type { FC } from "react"

import type { CommunityPostCategory } from "@forento/core/models/community"
import { cn } from "@forento/ui/utilities/tailwind"

type Props = {
	categories: CommunityPostCategory[]
	selectedCategoryId: number | null
	onSelect: (id: number | null) => void
}
const CategoryFilter: FC<Props> = ({ categories, selectedCategoryId, onSelect }) => (
	<fieldset aria-label="Filter posts by category" className="m-0 flex min-w-0 flex-wrap gap-2 border-0 p-0">
		{[{ id: null, label: "All categories" }, ...categories].map(({ id, label }) => {
			const isSelected = id === selectedCategoryId
			return (
				<button
					key={id ?? "all"}
					type="button"
					aria-pressed={isSelected}
					onClick={() => onSelect(id)}
					className={cn(
						"cursor-pointer rounded-full border px-3 py-1 text-sm font-medium transition-colors",
						isSelected
							? "border-primary bg-primary text-white"
							: "text-light border-gray-200 bg-white hover:text-black",
					)}
				>
					{label}
				</button>
			)
		})}
	</fieldset>
)

export default CategoryFilter
